import {
  BriefDeliverableTaskTypeEnum,
} from "@entities/brief/lib/constants";
import { IBriefDeliverableTaskConfig } from "@shared/lib/types/briefConfig";

export const STAGE_COLUMNS = [
  { key: BriefDeliverableTaskTypeEnum.Brief, label: "Brief" },
  { key: BriefDeliverableTaskTypeEnum.Script, label: "Script" },
  { key: BriefDeliverableTaskTypeEnum.Draft, label: "Draft" },
  { key: BriefDeliverableTaskTypeEnum.Live, label: "Live" },
];

export const findTaskForStage = (
  tasks: IBriefDeliverableTaskConfig[] | undefined,
  stageKey: string,
  stageLabel: string
) => {
  if (!tasks || tasks.length === 0) return undefined;
  const sKey = stageKey.toLowerCase();
  const sLabel = stageLabel.toLowerCase();
  return tasks.find((t) => {
    if (t.type && t.type.toLowerCase() === sKey) return true;
    if (
      t.name &&
      (t.name.toLowerCase().includes(sKey) ||
        t.name.toLowerCase().includes(sLabel))
    ) {
      return true;
    }
    return false;
  });
};
